import { ReactComponent as Icon } from "../files/check-filled-icon.svg";

import ISVGIconProps from "../ISVGIconProps";

const FilledCheckIcon = ({ fill, style = {} }: ISVGIconProps) => {
    return <Icon style={style} fill={fill} />;
};

export default FilledCheckIcon;
